// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1VJ42","avatar":"styles_avatar__1jGp3","textContent":"styles_textContent__2BWdS","text":"styles_text__3IhVZ"};